import React from 'react'
import { injectIntl } from 'react-intl'
import MUIButton from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import history from '../utilties/history'

const useStyles = makeStyles((theme) => ({
	root: {
		margin: '0',
		padding: '0',
		minWidth: '0',
		letterSpacing: '0.5px',
		"&:hover": {
			backgroundColor: '#fff'
		}
	},
	input: {
		display: 'none'
	}
}))

const LinkButton = ({
	intl,
	textId,
	type,
	size = 'large',
	width = '100px',
	path = '',
	backgroundColor = '',
	color = 'white',
	onClick = null,
	...other
}) => {
	const classes = useStyles()

	return (
		<MUIButton
			data-testid="link-button"
			variant="text"
			size={size}
			classes={{
				root: classes.root
			}}
			onClick={() => path && history.push(path)}
			style={{ textAlign: 'left', color }}
		>
			{intl.formatMessage({ id: textId })}
		</MUIButton>
	)
}

const enhance = compose(injectIntl)

export default enhance(LinkButton)
